import React from 'react';
import {connect} from 'react-redux';
import MapSectionEditPopup from './map_section_edit';
import { closeMapSectionPopup, updatePageMapSection } from '../../actions';
import { SECTION_TYPE_MAP } from '../../constants';
import { fetchSectionSettings } from '../../../pages/settings/thunks.js';
import { selectSectionSettingInTheSectionEditPopup } from '../../sections/actions';
import {
    updateBodyFieldInTheSectionEditPopup,
    updateInstructionsFieldInTheSectionEditPopup,
    updateMapLocationInTheSectionEditPopup,
    updateTitleFieldInTheSectionEditPopup
} from '../../sections/actions';

class MapPopup extends React.Component {
    componentWillUpdate(nextProps) {
        if (
            nextProps.mapSectionEditOpen === true &&
            this.props.mapSectionEditOpen === false
        ) {
            if (!this.props.allSectionSettings || this.props.allSectionSettings.length === 0) {
                this.props.fetchSectionSettings();
            }
        }
    }

    render() {
        const sectionSettings = this.props.allSectionSettings.filter(
            setting => Number(setting.section_type_id) === SECTION_TYPE_MAP
        );

        return (
            <MapSectionEditPopup
                open={this.props.mapSectionEditOpen}
                title={this.props.mapSectionTitle}
                body={this.props.mapSectionBody}
                instructions={this.props.mapSectionInstructions}
                pageId={this.props.mapSectionPageId}
                sectionId={this.props.mapSectionId}
                locations={this.props.mapSectionLocations}
                sectionSettings={sectionSettings}
                selectedSectionSettings={this.props.selectedSectionSettings}
                selectSectionSetting={this.props.selectSectionSetting}
                onUpdateTitleField={this.props.updateMapSectionTitleField}
                onUpdateInstructionsField={this.props.updateMapSectionInstructionsField}
                onUpdateBodyField={this.props.updateMapSectionBodyField}
                onUpdateLocationField={this.props.updateMapLocationField}
                onHandleRequestDone={() => this.props.updatePageMapSection(
                    this.props.pageId,
                    this.props.mapSectionId,
                    this.props.sectionData,
                    this.props.selectedSettings,
                    this.props.selectedSectionSettings,
                )}
                onHandleRequestClose={this.props.closeMapSectionPopup}
            />
        )
    }
}

const mapStateToProps = state => ({
    sectionData: state.pageBuilderSectionPopup.data,
    selectedSettings: state.pageBuilderSectionPopup.settings,
    mapSectionEditOpen: state.pageBuilder.mapSectionPopup.open,
    mapSectionTitle: state.pageBuilderSectionPopup.data.title,
    mapSectionBody: state.pageBuilderSectionPopup.data.body,
    mapSectionInstructions: state.pageBuilderSectionPopup.instructions,
    mapSectionPageId: state.pageBuilderSectionPopup.pageId,
    mapSectionId: state.pageBuilderSectionPopup.sectionId,
    mapSectionLocations: state.pageBuilderSectionPopup.data.locations,
    selectedSectionSettings: state.pageBuilderSectionPopup.sectionSettings,
    allSectionSettings: state.sectionsSettings.sectionSettings,
});

export default connect(
    mapStateToProps, {
        updateMapSectionTitleField: updateTitleFieldInTheSectionEditPopup,
        updateMapSectionInstructionsField: updateInstructionsFieldInTheSectionEditPopup,
        updateMapSectionBodyField: updateBodyFieldInTheSectionEditPopup,
        updateMapLocationField: updateMapLocationInTheSectionEditPopup,
        selectSectionSetting: selectSectionSettingInTheSectionEditPopup,
        fetchSectionSettings,
        updatePageMapSection,
        closeMapSectionPopup,
    }
)(MapPopup);


// WEBPACK FOOTER //
// ./src/containers/builder/form/popups/map_popup.js